import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { paymentLinksRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../../auth'
// Payment Links App
const PaymentLinksDashboardApp = () => import('@/pmd/pages/payments/PaymentLinksDashboard.vue')
const PaymentLinksEditorApp = () => import('@/pmd/pages/payments/PaymentLinksEditor.vue')

export const paymentLinksRoutes: RouteConfig[] = [
  {
    path: 'payments/v2/paymentlinks',
    name: paymentLinksRouteNames.listPaymentLinks,
    component: PaymentLinksDashboardApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/v2/paymentlinks/edit/:id',
    name: paymentLinksRouteNames.paymentLinksEditor,
    component: PaymentLinksEditorApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
    children: [],
  },
]
